export default __webpack_public_path__ + "static/media/refresh.6b7b161d.svg";